/* eslint-disable no-secrets/no-secrets */
/* eslint-disable arrow-body-style */
/* eslint-disable padding-line-between-statements */
import { BreakpointTrackerContext } from '@jutro/layout';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { QuestionSetComponent } from '@xengage/gw-portals-questionsets-ui';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import _, { clone } from 'lodash';
import React, { useCallback, useContext, useEffect, useState, useMemo } from 'react';
import { GatewayEndorsementService as EndorsementService } from 'twia-capability-gateway-policychange';
import TWIAJobHelper from 'ent-capability-quoteandbind-common-react/util/TWIAJobHelper';
import TWIAConstructionDetails from '../../components/ConstructionDetails/TWIAConstructionDetails/TWIAConstructionDetails';
import TWIARoofUpdatesComponent from 'ent-capability-quoteandbind-common-react/components/ConstructionDetails/ENTRoofUpdatesComponent/ENTRoofUpdatesComponent';
import TWIAAdditionalDetails from '../../components/ConstructionDetails/TWIAAdditionalDetails/TWIAAdditionalDetails';
import TWIARepairsOrAdditionsComponent from 'ent-capability-quoteandbind-common-react/components/ConstructionDetails/TWIARepairsOrAdditionsComponent/TWIARepairsOrAdditionsComponent';
import TWIACleanseObjUtil from '../../util/TWIACleanseObjUtil';
import msbInfoUtil from 'ent-capability-quoteandbind-common-react/util/MsbInfoUtil.js';
import metadata from './ConstructionPage.metadata.json5';
import styles from './ConstructionPage.module.scss';
import wizardStyles from '../../../../modules-react/twia-portals-wizard-components-ui/templates/TWIAWizardTemplate.module.scss';
import messages from './ConstructionPage.messages.js';
import { useTranslator } from '@jutro/locale';
import { Icon, InlineNotification, useModal } from '@jutro/components';
import { flow, updateWith } from 'lodash/fp.js';
import ErrorPopupUtil from 'ent-components-platform-react/util/ErrorPopupUtil.js';
import { GatewayRenewalService as RenewalService } from 'gw-capability-gateway-policyrenewal';
import { resetElectronicPaymentData } from 'ent-capability-quoteandbind-common-react/util/ResetElectronicData.js';


function TWIAConstructionPage(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { wizardData: submissionVM, updateWizardData, steps } = props;
    const { LoadSaveService } = useDependencies('LoadSaveService');
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const [showErrors, setShowErrors] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [errorDescription, setShowErrorDescription] = useState();
    const [errorSets, setErrorSets] = useState([]);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [hasMSBDataRefreshed, setMSBDataRefreshed] = useState(false);
    const isRenewal = _.get(submissionVM, 'baseData.jobType.value.code') == 'Renewal'
    const isPolicyChange = TWIAJobHelper.isPolicyChange(submissionVM.value);
    const isEitherChangeOrRenewal = TWIAJobHelper.isEitherRenewalOrPolicyChange(submissionVM.value);
    const [, updateState] = useState();
    // const msbInProgressTwia;
    const translator = useTranslator();
    const {
        isComponentValid,
        initialValidation,
        onValidate,
    } = useValidation('TWIAConstructionPage');

    const { refreshData } = useDataRefresh();

    const { showAlert } = useModal();

    // check to see if this is msb eligible. This is used to ensure the fields are set to read only if msbeligible.
    const isMSBEligible = _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.msbEligiblePolicyType_TWIA.value', false);
    const msbDataExists = _.get(submissionVM, 'lobData.homeowners.coverables.construction.msbDataExists_TWIA.value', false);
    useEffect(() => {
        TWIACleanseObjUtil.resetAspectsNotVisibleValues(submissionVM.lobData.homeowners.coverables.construction);
        if (submissionVM.value.errorsAndWarnings && submissionVM.value.errorsAndWarnings.validationIssues) {
            const errorMessagesSet = getValidationIssues(submissionVM.value.errorsAndWarnings.validationIssues);
            if (errorMessagesSet.length > 0) {
                setShowErrors(true);
                errorMessagesSet.forEach(msg => {
                    // If this is related to MSB and the message is the same as below then we should clear out all the msbfields for twia
                    // Address provided was not found by MSB. Please review and amend the location address or launch MSB to complete the valuation.
                    if(msg.startsWith("Address provided was not found by MSB.")){
                        msbInfoUtil(submissionVM,updateWizardData,authHeader).clearMsbFields_twia();
                    }
                });
                setErrorSets(errorMessagesSet);  
            }
        }
    }, []);

    const onLaunchMSB = useCallback(() =>{
       msbInfoUtil(submissionVM, updateWizardData, authHeader).launchMSB(translator, showAlert);
       setMSBDataRefreshed(false);
    }, []);

    // DE17305
    const onRefreshValuation = useCallback(() => {
       TWIACleanseObjUtil.resetAspectsNotVisibleValues(submissionVM);
        const updatedSubmissionVM = msbInfoUtil(submissionVM, updateWizardData, authHeader).refreshMSBValuation(translator, showAlert,getErrorMessages);

        setShowErrors(true);    
        setMSBDataRefreshed(true);      
    },[]);

    //DTO/PC validation errors
    const getFlowErrors = useCallback ((validationIssues) => {
        // if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 )|| (validationIssues.issues && validationIssues.issues.length > 0))) {
         let flowErrors = [];
         if (!_.isUndefined(validationIssues.fieldIssues) && validationIssues.fieldIssues.length > 0) {
             flowErrors = validationIssues.fieldIssues.filter((item) => {
                 return item.flowStepId === "HomeownersDwellingConstruction";
             }).map((item, index) => {
                 return item.reason;
             });
         }
         return flowErrors;
     }, []);
     
     // PC business errors eg: rating etc..
     const getValidationIssues = useCallback ((validationIssues) => {
        let errorReasons = [];
        let validationFlowReasons = [];
        const issues = _.get(validationIssues, 'issues');
        if (!_.isUndefined(issues) && issues.length > 0) {
            validationFlowReasons = issues.filter((item) => {
                return item.flowStepId === "HomeownersDwellingConstruction";
            }).map((item) => {
                return item.reason;
            });
            errorReasons = issues.filter((item) => {
                return _.isUndefined(item.flowStepId) && item.type !== 'warning' 
                && !_.includes(item.reason, 'Please upload');
            }).map((item) => {
                return item.reason;
            });
        }
 
        return [...errorReasons, ...validationFlowReasons];
      }, []);

    // Combination of all types of errors in quote wizard
    const getErrorMessages = useCallback ((validationIssues) => {
        if (validationIssues && ((validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 )|| (validationIssues.issues && validationIssues.issues.length > 0))) {
            let flowErrors = [];
            if (validationIssues.fieldIssues && validationIssues.fieldIssues.length > 0 ) {
                flowErrors = validationIssues.fieldIssues.filter((item) => {
                    return item.flowStepId === "HomeownersDwellingConstruction";
                }).map((item, index) => {
                    return item.reason;
                });
            }
            let errorReasons = [];
            let validationFlowReasons = [];
            if (validationIssues.issues && validationIssues.issues.length > 0) {
                validationFlowReasons = validationIssues.issues.filter((item) => {
                    return item.flowStepId === "HomeownersDwellingConstruction";
                }).map((item, index) => {
                    return item.reason;
                });
                errorReasons = validationIssues.issues.filter((item) => {
                    return _.isUndefined(item.flowStepId) && !item.reason.includes("Please upload");
                }).map((item, index) => {
                    return item.reason;
                });
            }
            refreshData();
            let messages = [...flowErrors, ...validationFlowReasons, ...errorReasons];
            if(messages.length > 0) {
                setShowErrorMessage(true);
                setErrorSets(messages);
                return true;
            } else {
                setShowErrorMessage(false);
                setErrorSets([]);
                return false;
            }
        } else {
            setShowErrorMessage(false);
            setErrorSets([]);
            refreshData();
            return false;
        }
        
    }, [setShowErrorDescription, setShowErrorMessage, setErrorSets, errorSets, refreshData]);

    const checkForIssues = useCallback(() => {
        const { validationIssues } = submissionVM.value.errorsAndWarnings;
        if (validationIssues && validationIssues.issues && validationIssues.issues.length > 0) {
            if (validationIssues.issues[0].flowStepId === "HomeownersDwellingConstruction") {
                setShowErrorMessage(true);
                setShowErrorDescription(validationIssues.issues[0].reason);
                return false;
            }
        }
        return true;
    }, [submissionVM]);

    const saveData = useCallback(async () => {
        try {
            const newSubmissionVM = viewModelService.clone(submissionVM);
            if (!isRenewal) {
                _.set(newSubmissionVM, 'lobData.homeowners.offerings', undefined);
            }
            _.set(submissionVM, 'baseData.policyContactDetails_TWIA[0].primaryAddress.mustStandardize_Ext', false);

            // DE18275
            if (!_.get(newSubmissionVM,'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.aspects.visible')) {
                _.set(newSubmissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA', undefined);
            }

            const validationParams = {
                skipAllValidation: false,
                validationLevel: "default",
                validationWizardStep: "DwellingConstruction"
            }

            _.set(newSubmissionVM, 'validationParams_TWIA.value', validationParams);
            resetElectronicPaymentData(submissionVM, updateWizardData)
            // DE18275
            resetElectronicPaymentData(newSubmissionVM, updateWizardData)

            if (isRenewal) {
                submissionVM.value = await RenewalService.saveRenewal(
                    newSubmissionVM.value,
                    authHeader
                )
            } else if(isPolicyChange){ 
                submissionVM.value = await EndorsementService.saveAndQuoteSubmission(
                    [newSubmissionVM.value],
                    authHeader
                )
            }
            else {
                submissionVM.value = await LoadSaveService.updateDraftSubmission(
                    newSubmissionVM.value,
                    authHeader
                )
            }
            updateWizardData(submissionVM);
        } catch {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            return false;
        }
    }, [viewModelService, submissionVM, LoadSaveService, authHeader, updateWizardData, showAlert]);

    const onNext = useCallback(async () => {
        if (invalidComponent.length > 0) {
            setShowErrors(true)
            return false;
        }
        setShowErrors(false);
        _.set(submissionVM, 'baseData.accountHolder.primaryPhoneType.value', undefined); //DE18500
        return saveData().then(()=>{
            if (submissionVM.value.errorsAndWarnings) {
                const result = getErrorMessages(submissionVM.value.errorsAndWarnings.validationIssues);
                if(result === false) {
                    setShowErrors(false);
                    // return submissionVM;
                } else {
                    setShowErrors(true)
                    return false;
                };
                // check msb status 
                const msbInfo = msbInfoUtil(submissionVM, updateWizardData, authHeader).msbStatusInfo();
                if (!msbInfo.msbValuationCompleted) {
                    msbInfoUtil(submissionVM,  updateWizardData, authHeader).msbShowErrorDialog(msbInfo, translator, showAlert);
                    return false;
                }
                else {
                    msbInfoUtil(submissionVM, updateWizardData, authHeader).setAllConstructionFieldsValidationTwia(true);
                    return submissionVM;
                }
            }
           // return false;
        }).catch(()=> {
            ErrorPopupUtil.showSaveErrorPopup(showAlert, true);
            return false;
        });
    
    }, [invalidComponent, saveData, submissionVM, getErrorMessages, 
        updateWizardData, authHeader, showAlert]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const errorContent = useCallback(
        item => {
            return (
                <InlineNotification id={item} 
                message={item}
                type= "error"
                className= {wizardStyles.marginBottom}
                isDismissable= {false}
                />
            );
        },
        []
    );

    const generateOverrides = useMemo(() => {
        const overrides = errorSets.map((item, index) => {
            return {
                [`errorMsg${index}`]: {
                    content: errorContent(item),
                },
            };
        });
        return Object.assign({}, ...overrides);
    }, [errorSets, errorContent]);
    
    // DE15501
    const currentLocationCounty = _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.primaryAddress_TWIA.county.value');
    
    function harrisCountyMessage() {
        return (
            <div>
                <span style={{ display: 'flex' }}>
                    <Icon id="icon" icon="gw-info" title="Info" color="#4074ce" />
                    <h5 style={{ paddingLeft: '4px'}}>{'Info: '}</h5>
                    <text style={{ paddingLeft: '6px'}}>{translator(messages.messageLine0)}</text>
                </span>
                <ol style={{ marginBottom: '0rem', marginLeft: '2.2rem'}} start="1">
                    <li>{translator(messages.messageLine1)}</li>
                    <li>{translator(messages.messageLine2)}</li>
                    <li>{translator(messages.messageLine3)}</li>
                </ol>
            </div>
        );
    };

    const skipCondition = useCallback( // DE17134
        () => {
            if (initialValidation && !_.isNull(isComponentValid)) {
                return initialValidation() && isComponentValid;
            }
            if (!(submissionVM.lobData.homeowners.coverables.construction.aspects.subtreeValid)) {
                return false;
            }
            const validations = _.get(submissionVM.value, 'errorsAndWarnings.validationIssues')
            const errorMessagesSet = getValidationIssues(validations);
            return initialValidation() && (errorMessagesSet.length === 0);
        }, [getValidationIssues, initialValidation, isComponentValid, submissionVM]
    );

    const overrideProps = {
        '@field': {
            // apply to all fields
            showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        constructionDetails: {
            submissionVM, isMSBEligible, updateWizardData, showErrors, findInvalidComponent, steps, onValidate, isRenewal, isEitherChangeOrRenewal
        },
        addlConstruction: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate, isRenewal, isEitherChangeOrRenewal, authHeader, hasMSBDataRefreshed
        },
        roofUpdates: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate,
        },
        repairsOrAdds: {
            submissionVM, updateWizardData, showErrors, findInvalidComponent, onValidate,
        },
        constructionDetailsAccordion: {
            errorState: _.includes(invalidComponent, 'TWIAConstructionDetails') && showErrors
        },
        roofUpdatesAccordion: {
            // DE15576
            errorState: (_.includes(invalidComponent, 'RoofDetails')) || (_.includes(invalidComponent, 'ENTRoofUpdatesComponent') && showErrors),
            title: _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRM' ? translator(messages.mhTitleRoofDetails) : translator(messages.titleRoofDetails) // DE15494
        },
        repairOrAdditionsAccordion: {
            // DE15576
            errorState: _.includes(invalidComponent, 'RepairsOrAdditions'),
            title: _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRM' ? translator(messages.mhTitleRepairsAdditions) : translator(messages.titleRepairsAdditions) // DE15494
        },
        additionalConstructionAccordion: {
            errorState: _.includes(invalidComponent, 'TWIAAdditionalDetails') && showErrors,
            visible: _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') !== 'TWRM' // DE15494
        },
        additionalConstructionAccordionMH: {
            errorState: _.includes(invalidComponent, 'TWIAAdditionalDetails') && showErrors,
            visible: _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRM' ? true : false,
        },
        infoMessage: {
            visible: showErrorMessage,
            message: errorDescription
        },
        accordionBreak: {
            visible: showErrorMessage
        },
        inforMessageL: {
            data: errorSets
        },
        harrisCountyMessage: { // DE15501
            visible: currentLocationCounty === 'Harris',
            content: harrisCountyMessage()
        },
        refreshValuationId:{
            visible:  _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRD' && msbInfoUtil(submissionVM, updateWizardData, authHeader).isRefreshMSBAvailable()
        },
        launchMSBId:{
            visible: _.get(submissionVM.value, 'lobData.homeowners.policyType_TWIA') === 'TWRD' && msbInfoUtil(submissionVM, updateWizardData, authHeader).shouldLaunchMSB_TWIA()
        },
        ...generateOverrides,  
    };

    const resolvers = {
        resolveComponentMap: {
            questionset: QuestionSetComponent,
            constructionDetailsComponent: TWIAConstructionDetails,
            roofUpdatesComponent: TWIARoofUpdatesComponent,
            addlConstructionComponent: TWIAAdditionalDetails,
            repairsOrAddsComponent: TWIARepairsOrAdditionsComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap:{
            onLaunchMSB,
            onRefreshValuation,
            skipCondition
        }
    };

    return (
        <WizardPage
            onNext={onNext}
            skipWhen={skipCondition} // DE17134
            //disableNext={!isComponentValid}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                showErrors={showErrors}
                onModelChange={updateWizardData}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

TWIAConstructionPage.propTypes = wizardProps;
export default TWIAConstructionPage;
